import React from "react";
import style from './CustomFalseCeiling.module.scss';
import { ReactComponent as SpotLight } from '../../../assets/icons/spotLight.svg';
import { ReactComponent as PanelLight } from '../../../assets/icons/panelLight.svg';
import { ReactComponent as DecorativeLight } from '../../../assets/icons/decorativeLight.svg';
import { ReactComponent as Fan } from '../../../assets/icons/fan.svg';
import { ReactComponent as PendentLight } from '../../../assets/icons/pendantLight.svg';
import { ReactComponent as SplitAC } from '../../../assets/icons/splitAC.svg';

const CustomFalseCeilingLegends = () => {
  return (
    <div className={style.legend_container}>
      {/* <div className={style.legends_row}>
        <p>Spot Light: <SpotLight /></p>
        <p>Panel Light: <PanelLight /></p>
      </div>
      <div className={style.legends_row}>
        <p>Deco. Light: <DecorativeLight /> </p>
        <p>Fan: <Fan /> </p>
      </div>
      <div className={style.legends_row}>
        <p>Pendant Light: <PendentLight /></p>
        <p>Split AC: <SplitAC /></p>
      </div> */}
    </div>
  )
}

export default CustomFalseCeilingLegends;